import { FC } from 'react';

const MoneyIcon: FC<any> = (props) => {
    return (
        <svg
            width={48}
            height={48}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={48} height={48} rx={24} fill="#EEE6FF" />
            <path
                d="M22.336 20.475c.246-.195.538-.337.851-.427v3.028a2.441 2.441 0 01-.851-.426c-.427-.34-.592-.738-.592-1.088 0-.35.165-.748.592-1.087zm2.476 7.492v-3.06c.376.093.72.248.998.457.463.346.627.743.627 1.073 0 .33-.165.727-.627 1.074a2.746 2.746 0 01-.998.456z"
                fill="#639"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 13.438c-5.834 0-10.563 4.728-10.563 10.562S18.168 34.563 24 34.563c5.834 0 10.563-4.73 10.563-10.563 0-5.834-4.73-10.563-10.563-10.563zm.813 4.062a.812.812 0 10-1.625 0v.884c-.68.114-1.32.396-1.864.819-.771.613-1.205 1.463-1.205 2.36 0 .898.434 1.746 1.206 2.359.544.433 1.194.7 1.863.819v3.226c-.36-.083-.7-.238-.998-.456l-.953-.715a.813.813 0 00-.974 1.3l.952.715a4.469 4.469 0 001.973.813v.876a.812.812 0 101.625 0v-.878a4.468 4.468 0 001.972-.81c.807-.607 1.277-1.457 1.277-2.375 0-.917-.47-1.768-1.277-2.373a4.467 4.467 0 00-1.973-.813v-3.2c.315.088.606.23.852.425l.45.357a.813.813 0 101.01-1.272l-.45-.358a4.156 4.156 0 00-1.861-.818V17.5z"
                fill="#639"
            />
        </svg>
    );
};

export default MoneyIcon;
